module.exports = __webpack_public_path__ + "img/afghanistan.9b586c0b.svg";